import React from 'react';
import cn from '@/utils/cn';

export interface BreadcrumbItem {
  href?: string;
  label: string;
}

interface Props {
  items: BreadcrumbItem[];
  largerFont?: boolean;
}

// This is a React Component that was converted from code in breadcrumbs_helper.rb
const Breadcrumbs = ({ items, largerFont = false }: Props) => (
  <div className={cn('breadcrumbs', {
    'tw-flex tw-items-center tw-text-sm tw-mb-0': largerFont,
  })}
  >
    {items.map((item, index) => {
      const isLast = index === items.length - 1;

      if (isLast) {
        return (
          <span
            key={`breadcrumb-item-label-${item.label}`}
            className={cn('tw-font-bold', { 'tw-text-[#555]': largerFont })}
          >
            {item.label}
          </span>
        );
      }

      const linkClassName = `tw-text-purple tw-text-sm hover:tw-underline
                             tw-text-ellipsis tw-nowrap tw-overflow-hidden
                             tw-whitespace-nowrap tw-max-w-[14rem] chromebook-plus:tw-max-w-none`;

      return (
        <React.Fragment key={`breadcrumb-item-${item.label}`}>
          <a
            className={cn({ [linkClassName]: largerFont })}
            href={item.href}
          >
            {item.label}
          </a>
          {largerFont ? (
            <i className="fa fa-caret-right tw-mx-2 tw-text-black tw-text-lg" />
          ) : (
            <span> / </span>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default Breadcrumbs;
